import { apiDownloadFile } from '@/apis/fileManage';

// 文件下载
export function downLoadFunc(src, filename, type) {
  const blobType = type === 'zip' ? 'application/zip' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
  const blob = new Blob([src], { type: blobType });
  const href = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = filename;
  a.href = href;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(a.href);
  document.body.removeChild(a);
}

// 下载url文件
export function downloadUrlFile(fileUrl, fileName) {
  apiDownloadFile({ fileUrl, fileName }).then((res) => {
    let fileName = '';
    try {
      // eslint-disable-next-line prefer-destructuring
      fileName = res.filename.split('=')[1] || res.headers['content-disposition'].split('=')[1];
      fileName = decodeURIComponent(fileName);
    } catch (error) {
      console.log('error----->', error)
    }
    const type = fileName.includes('.zip') ? 'zip' : 'excel';
    downLoadFunc(res.blob, fileName, type);
  });
}

// 下载url文件
// export function downloadUrlFile(url, filename) {
//   fetch(url)
//     .then(response => response.blob())
//     .then(blob => {
//       const blobUrl = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = blobUrl;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(blobUrl);
//     }).catch(() => {
//       window.open(url)
//     });
// }

// export function downloadUrlFile(url, filename) {
//   try {
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   } catch (error) {
//     window.open(url)
//   }
// }
